module.exports = __webpack_public_path__ + "img/GH-kyujin-top-pa002.bc245e7f.webp";